export default {
  headers: [
    ['satellite-tracking/report.time', 'time'],
    ['Tovarni prostor', 'temperatureSensor1'],
    ['Rashladna komora', 'temperatureSensor2'],
    ['Hladnjak', 'temperatureSensor3'],
    ['satellite-tracking/report.door', 'door_opened']
  ]
}
